<template>
  <v-switch
    :input-value="value"
    :label="item ? item : label "
    :style="{ 'font-weight' : 'bold' }"
    :disabled="disabled"
    :readonly="readonly"
    :error-messages="getErrors(validator)"
    @change="$emit('input', $event) && validator && validator.$touch()"
    @blur="validator && validator.$touch()"
  />
</template>

<script>

import { defaultMessages, getValidationErrors } from './../../../utils'

export default {
  name: 'switch-field',
  props: {
    disabled: Boolean,
    readonly: Boolean,
    label: {
      type: String,
      default: '',
    },
    item: {
      type: String,
      default: '',
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    value: Boolean,
  },
  methods: {
    getErrors: function(field){
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>

<style>
</style>
